import { useState, useEffect } from "react";
import { GetRangeByDuration } from "../../helper";
import UseGql from "@/services/graph-ql/useGql";
import { WidgetDurationEnums } from "@/services/dropdown-enums";
import GraphTable from "./graph-table";
import { time } from "@/modules/crm/global/constants";

const WidgetGraphWrapperLeadGenerated = ({
  value = 0,
  query,
  dataKey = "",
  paramKey = "createdOn",
  loading = false,
  columns = [],
}) => {
  const [durationsData, setDurationsData] = useState({});
  const { executeQuery } = UseGql(query, { variables: {} }, "report", {}, true);

  useEffect(() => {
    Object.keys(WidgetDurationEnums).forEach((key) => {
      fetchByDurations(key);
    });
  }, []);

  const makeParams = (obj = {}) => {
    return {
      where: {
        and: [
          { [paramKey]: { gte: obj?.gte } },
          { [paramKey]: { lte: obj?.lte } },
        ],
      },
    };
  };
  const fetchByDurations = (key) => {
    const { first } = GetRangeByDuration(
      key.toLowerCase(),
      time.format.standardDate,
      true
    );
    const reqParams = makeParams(first);

    executeQuery(reqParams).then((res) => {
      const { data } = res;
      if (data && data?.[dataKey]) {
        setDurationsData((prev) => ({
          ...prev,
          [key]: data?.[dataKey]?.totalCount,
        }));
      }
    });
  };

  const generateData = (arg = {}) => {
    let data = Object.keys(WidgetDurationEnums).map((k, index) => ({
      overTime: k.split("_").join(" "),
      count: arg[k],
    }));
    return data;
  };
  // console.log(durationsData, columns);

  return (
    <GraphTable
      data={generateData(durationsData)}
      columns={columns}
      value={value}
      loading={loading}
    />

    // <Card>
    //   <CardContent
    //     className="custom-scroll"
    //     sx={{ height: "calc(100vh - 165px)", overflowY: "auto", mb: 1 }}
    //   >
    //     <Box
    //       sx={{
    //         width: "max-content",
    //         background: colorEnums.purple.bg,
    //         color: colorEnums.purple.text,
    //         borderRadius: "10px",
    //         px: 4,
    //         py: 3,
    //         fontSize: "3rem",
    //         mb: 2,
    //       }}
    //     >
    //       {loading ? <CircularProgress size={"17px"} /> : value}
    //     </Box>
    //     {/* grid */}
    //     <Box>
    //       <TableContainer component={Paper}>
    //         <Table sx={{ minWidth: "auto" }} aria-label="simple table">
    //           <TableHead sx={{ background: "#F2FAFB" }}>
    //             <TableRow>
    //               {columns.map((col, index) => (
    //                 <TableCell key={index} sx={{ width: "200px" }}>
    //                   {col.title}
    //                 </TableCell>
    //               ))}
    //             </TableRow>
    //           </TableHead>
    //           <TableBody>
    //             {Object.keys(WidgetDurationEnums).map((key, index) => (
    //               <TableRow
    //                 key={index}
    //                 sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
    //               >
    //                 <TableCell component="th" scope="row">
    //                   {durationsData[key]}
    //                   {loader ? <CircularProgress size={"17px"} /> : null}
    //                 </TableCell>
    //                 <TableCell>{key.split("_").join(" ")}</TableCell>
    //               </TableRow>
    //             ))}
    //           </TableBody>
    //         </Table>
    //       </TableContainer>
    //     </Box>
    //   </CardContent>
    // </Card>
  );
};

export default WidgetGraphWrapperLeadGenerated;
